import React, { Component } from 'react';
import './App.css';
import FadeInText from './components/FadeInText';
import ContactForm from './components/ContactForm';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import themeColor from '@material-ui/core/colors/grey';

const theme = createMuiTheme({
  palette: {
    primary: themeColor,
  },
});

class App extends Component {
  
  componentWillMount() {
    //window.obf();
  }
  
  render() {
    return (
      <div className="bg">
          <MuiThemeProvider theme={theme}>
            <FadeInText />
            <ContactForm />
          </MuiThemeProvider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js